class GuardedHeightObserver extends HTMLElement {
  connectedCallback() {
    this.variable = this.getAttribute('variable') || 'header';
    this.resizeObserver = new ResizeObserver(() => this.update());
    this.resizeObserver.observe(this);
    this.update();
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }

  update() {
    const height = this.clientHeight;
    if (height > 0) {
      document.documentElement.style.setProperty(`--${this.variable}-height`, `${height}px`);
    }
  }
}

if (!customElements.get('guarded-height-observer')) {
  window.customElements.define('guarded-height-observer', GuardedHeightObserver);
}
